import {
  usePagination,
  useSorting,
  useQuotesFilters,
  useQuotesHistory,
} from '../../hooks';
import { QuotesTable } from '../QuotesTable/QuotesTable.component';
import { QuotesHistoryTableProps } from './QuotesHistoryTable.props';

export const QuotesHistoryTable = ({
  mode,
  filters,
}: QuotesHistoryTableProps) => {
  const sorting = useSorting('lastModified', { sortDirection: 'desc' });
  const pagination = usePagination();
  const { filter, composite } = useQuotesFilters(filters);
  const { list, loading, getFirestoreQuery } = useQuotesHistory({
    filters: filter,
    sorting,
    pagination,
    compositeFilters: composite,
  });

  return (
    <QuotesTable
      fetchAllQuery={getFirestoreQuery(true)}
      mode={mode}
      pagination={pagination}
      quotes={!loading ? list : undefined}
      sorting={sorting}
    />
  );
};

export default QuotesHistoryTable;
